import { TypedDocumentNode, gql } from '@apollo/client';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineM } from '@sorare/core/src/atoms/typography';

import { So5LeaderboardGroupWrapper_so5LeaderboardGroupInterface } from './__generated__/index.graphql';

export const Root = styled(Vertical)`
  background-color: rgba(var(--c-rgb-neutral-1000), 0.1);
  border-radius: var(--intermediate-unit);
  padding: var(--double-unit);
`;

export const LeagueIcon = styled.img`
  width: var(--quadruple-unit);
  height: var(--quadruple-unit);
  margin-right: var(--unit);
`;

type Props = {
  children: ReactNode;
  so5LeaderboardGroupInterface: So5LeaderboardGroupWrapper_so5LeaderboardGroupInterface;
};

export const So5LeaderboardGroupWrapper = ({
  children,
  so5LeaderboardGroupInterface,
}: Props) => {
  const { displayName, iconUrl } = so5LeaderboardGroupInterface;
  return (
    <Root>
      <HeadlineM color="var(--c-neutral-600)">
        {iconUrl && <LeagueIcon alt={displayName} src={iconUrl} width="20" />}
        {displayName}
      </HeadlineM>
      {children}
    </Root>
  );
};

So5LeaderboardGroupWrapper.fragments = {
  so5LeaderboardGroupInterface: gql`
    fragment So5LeaderboardGroupWrapper_so5LeaderboardGroupInterface on So5LeaderboardGroupInterface {
      slug
      displayName
      iconUrl
    }
  ` as TypedDocumentNode<So5LeaderboardGroupWrapper_so5LeaderboardGroupInterface>,
};
